import { v5, v7 } from 'uuid';
import { WIZTIME_NS } from '../model/constants';
import type { DefaultProjectKey } from '../model/enums';

/** New random identifier (UUIDv7, time-ordered). `nowMs` injects the clock; omitted uses the library clock. */
export function newId(nowMs?: number): string {
  return nowMs === undefined ? v7() : v7({ msecs: nowMs });
}

/** Deterministic identifier (UUIDv5 in the WizTime namespace) of a business key. */
function deterministicId(name: string): string {
  return v5(name, WIZTIME_NS);
}

/** Data dictionary §4: name strings of deterministic identifiers. */

export function checkinLogId(itemId: string, personalDate: string): string {
  return deterministicId(`checkinLog:${itemId}:${personalDate}`);
}

export function dailyNoteId(personalDate: string): string {
  return deterministicId(`dailyNote:${personalDate}`);
}

export function settingId(key: string): string {
  return deterministicId(`setting:${key}`);
}

export function templateDraftId(personalDate: string, templateId: string): string {
  return deterministicId(`draft:${personalDate}:template:${templateId}`);
}

export function repeatDraftId(
  personalDate: string,
  projectId: string,
  startMin: number,
  endMin: number,
): string {
  return deterministicId(`draft:${personalDate}:repeat:${projectId}:${startMin}-${endMin}`);
}

/**
 * A piece of a block that was cut at a personal-day boundary when the block was merged from a
 * device with another day start. Named by the position of the piece so that every device derives
 * the same identifier for the same piece.
 */
export function blockPieceId(
  blockId: string,
  personalDate: string,
  startMin: number,
  endMin: number,
): string {
  return deterministicId(`blockPiece:${blockId}:${personalDate}:${startMin}-${endMin}`);
}

export function defaultProjectId(key: DefaultProjectKey): string {
  return deterministicId(`defaultProject:${key}`);
}
